import { createFileRoute } from "@tanstack/react-router";
import { parseSalesTeamSearch } from "@/features/sales-team/search";

/**
 * Phòng Kinh doanh (QĐ 0483). Thẻ và tháng nằm trên đường dẫn — bấm Quay lại
 * là về đúng thẻ, và gửi link cho người khác được.
 */
export const Route = createFileRoute("/_app/sales-team/")({
  validateSearch: parseSalesTeamSearch,
});
